/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const ShareIcon = createIcon({
  displayName: 'ShareIcon',
  viewBox: '0 0 20 20',
  path: [
    <path
      d="M13.7002 7.41602C16.7002 7.67435 17.9252 9.21602 17.9252 12.591V12.6993C17.9252 16.4243 16.4336 17.916 12.7086 17.916H7.28356C3.55856 17.916 2.06689 16.4243 2.06689 12.6993V12.591C2.06689 9.24102 3.27523 7.69935 6.22523 7.42435"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M10 12.5009V3.01758"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path
      d="M12.7918 4.87565L10.0002 2.08398L7.2085 4.87565"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
